import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f5a79bd")

_pushScopeId("data-v-3f5a79bd")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "学習室作成", -1)
const _hoisted_4 = { class: "flex-grow flex flex-col items-center bg-primary-100 overflow-y-scroll pt-12" }
const _hoisted_5 = {
  key: 0,
  class: "panel-container"
}
const _hoisted_6 = {
  key: 1,
  class: "panel-container bg-white flex flex-col mb-12 px-4 py-3 rounded-md"
}
const _hoisted_7 = { class: "flex flex-col lg:flex-row lg:justify-between items-center" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "font-medium" }, " 開室中の学習室はありません ", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "学習室作成", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_room_panel = _resolveComponent("m-room-panel")
  const _component_MREditEndTimeModal = _resolveComponent("MREditEndTimeModal")
  const _component_MRJoinModal = _resolveComponent("MRJoinModal")
  const _component_mr_send_modal = _resolveComponent("mr-send-modal")
  const _component_mr_add_modal = _resolveComponent("mr-add-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_MNavBar),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_MHeaderPanel, {
          title: "学習室情報",
          breadcrumbs: [],
          tabs: _ctx.tabs,
          "current-tab-index": _ctx.currentTabIndex
        }, {
          actions: _withId(() => [
            (_ctx.allowCreateRoom || _ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_m_button, {
                  key: 0,
                  color: "secondary-500",
                  "hover-color": "secondary-600",
                  outline: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDisplayedAddRoomModal = true))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_m_icon, {
                      type: "plus",
                      width: "3",
                      class: "mr-2 transform rotate-90 z-0"
                    }),
                    _hoisted_3
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["tabs", "current-tab-index"]),
        _createVNode("main", _hoisted_4, [
          (_ctx.rooms.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rooms, (room) => {
                  return (_openBlock(), _createBlock(_component_m_room_panel, {
                    key: room.ref.id,
                    room: room,
                    "is-admin": _ctx.isAdmin,
                    registrants: _ctx.registrantsOfRoom(room.ref.id),
                    students: _ctx.students,
                    "student-secrets": _ctx.studentSecrets,
                    schools: _ctx.schools,
                    classrooms: _ctx.classrooms,
                    class: "mb-8",
                    onDeleteRoom: ($event: any) => (_ctx.deleteRoom(room.data.meetingId, room.data.name)),
                    onJoin: ($event: any) => (_ctx.joinRoom(room.ref.id)),
                    onJoinHost: ($event: any) => (_ctx.hostJoinRoom(room.ref.id)),
                    onOpenSendModal: ($event: any) => (_ctx.showSendModal(room.ref.id)),
                    onEditEndTime: ($event: any) => (_ctx.showEditEndTimeModal(room.ref.id, room.data.end))
                  }, null, 8, ["room", "is-admin", "registrants", "students", "student-secrets", "schools", "classrooms", "onDeleteRoom", "onJoin", "onJoinHost", "onOpenSendModal", "onEditEndTime"]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("section", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  (_ctx.allowCreateRoom || _ctx.isAdmin)
                    ? (_openBlock(), _createBlock(_component_m_button, {
                        key: 0,
                        color: "primary-500",
                        "hover-color": "primary-600",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDisplayedAddRoomModal = true))
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_m_icon, {
                            type: "plus",
                            width: "4",
                            class: "mr-2"
                          }),
                          _hoisted_9
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
        ])
      ])
    ]),
    (_ctx.isDisplayEditEndTimeModal && _ctx.selectedRoom)
      ? (_openBlock(), _createBlock(_component_MREditEndTimeModal, {
          key: 0,
          "meeting-id": _ctx.selectedRoomId,
          "end-time": _ctx.endTime,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDisplayEditEndTimeModal = false))
        }, null, 8, ["meeting-id", "end-time"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayJoinModal)
      ? (_openBlock(), _createBlock(_component_MRJoinModal, {
          key: 1,
          url: _ctx.startUrl,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDisplayJoinModal = false))
        }, null, 8, ["url"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplaySendModal)
      ? (_openBlock(), _createBlock(_component_mr_send_modal, {
          key: 2,
          students: _ctx.studentsOfSelectedRoom,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isDisplaySendModal = false))
        }, null, 8, ["students"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayedAddRoomModal)
      ? (_openBlock(), _createBlock(_component_mr_add_modal, {
          key: 3,
          school: _ctx.school,
          groups: _ctx.groups,
          targets: _ctx.targets,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDisplayedAddRoomModal = false))
        }, null, 8, ["school", "groups", "targets"]))
      : _createCommentVNode("", true)
  ], 64))
})